import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleLayout from "@/components/feature/ArticleLayout";
import PageMeta from "@/components/base/PageMeta";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://usfansspreadsheet.help";
const articlePath = "/artykul/spolecznosc-usfansspreadsheet";
const articleTitle = "Społeczność USFansSpreadsheet – forum, wsparcie i porady";
const articleDesc = "Poznaj społeczność USFansSpreadsheet – forum użytkowników, profesjonalne wsparcie techniczne 24/7 i miejsce wymiany doświadczeń. Dołącz już dziś.";

const articleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": articleTitle,
  "description": articleDesc,
  "author": { "@type": "Person", "name": "Anna Kowalska", "jobTitle": "Specjalista SEO" },
  "datePublished": "2026-06-13",
  "dateModified": "2026-06-24",
  "publisher": { "@type": "Organization", "name": "USFansSpreadsheet.help", "url": siteUrl },
  "mainEntityOfPage": { "@type": "WebPage", "@id": `${siteUrl}${articlePath}` },
  "inLanguage": "pl-PL"
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Strona główna", "item": siteUrl },
    { "@type": "ListItem", "position": 2, "name": "Artykuły", "item": `${siteUrl}/artykul/przewodnik-usfansspreadsheet` },
    { "@type": "ListItem", "position": 3, "name": "Społeczność" }
  ]
};

const relatedArticles = [
  { title: "Kompletny przewodnik po USFansSpreadsheet", to: "/artykul/przewodnik-usfansspreadsheet" },
  { title: "10 praktycznych wskazówek", to: "/artykul/wskazowki-usfansspreadsheet" },
  { title: "USFansSpreadsheet dla początkujących", to: "/artykul/dla-poczatkujacych" },
];

export default function ArticleCommunity() {
  return (
    <>
      <PageMeta
        title={articleTitle}
        description={articleDesc}
        keywords="USFansSpreadsheet, społeczność, forum, wsparcie, pomoc, użytkownicy, porady, Polska"
        canonicalPath={articlePath}
        ogType="article"
      />
      <JsonLd data={articleSchema} />
      <JsonLd data={breadcrumbSchema} />

      <Navbar />
      <ArticleLayout title="Społeczność USFansSpreadsheet – forum, wsparcie i porady" category="Społeczność" heroImg="https://readdy.ai/api/search-image?query=Community%20forum%20concept%20with%20multiple%20small%20avatar%20bubbles%20around%20a%20central%20laptop%20screen%20on%20a%20warm%20cream%20surface%2C%20soft%20diffused%20lighting%2C%20friendly%20welcoming%20atmosphere%2C%20modern%20social%20tech%20photography%2C%20clean%20composition%20with%20gentle%20warm%20tones&width=1400&height=600&seq=art-comm-hero-v2&orientation=landscape" heroImgAlt="Społeczność USFansSpreadsheet" relatedArticles={relatedArticles}>
        <p className="text-lg md:text-xl text-foreground-800 font-medium leading-relaxed">Poznaj społeczność <strong>USFansSpreadsheet</strong> — miejsce, gdzie użytkownicy dzielą się wiedzą, doświadczeniami i pomagają sobie nawzajem w rozwiązywaniu problemów.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Forum użytkowników</h2>
        <p>Forum <strong>USFansSpreadsheet</strong> to aktywne miejsce, gdzie znajdziesz odpowiedzi na najczęściej zadawane pytania, porady od doświadczonych użytkowników oraz najnowsze informacje o aktualizacjach.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Wsparcie techniczne</h2>
        <p>Zespół <strong>USFansSpreadsheet</strong> oferuje profesjonalne wsparcie techniczne dostępne 24 godziny na dobę, 7 dni w tygodniu. Niezależnie od problemu, możesz liczyć na szybką i fachową pomoc.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Jak dołączyć do społeczności</h2>
        <p>Dołączenie do społeczności <strong>USFansSpreadsheet</strong> jest bezpłatne i otwarte dla wszystkich użytkowników. Wystarczy zarejestrować się na forum i rozpocząć dyskusję.</p>
      </ArticleLayout>
      <Footer />
    </>
  );
}